/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   gets feedName based on providerId
 */

import { EVOLVE, JUNE_HOMES } from '@zcode/nr/es/shared/constants/source'
import type {
  ListableBuilding,
  ListableListing,
  NormalNonFloorplanListingData,
  Property,
  ShortTermViewListing,
} from '@zcode/state-type'

export function getFeedName(
  entity: ShortTermViewListing<NormalNonFloorplanListingData>
): (typeof entity)['feedName'] | typeof EVOLVE
export function getFeedName(
  entity?: Pick<
    Property | ListableBuilding | ListableListing,
    'feedName' | 'providerIdOrigin'
  > | null
): string
export function getFeedName(
  entity?: Pick<
    Property | ListableBuilding | ListableListing,
    'feedName' | 'providerIdOrigin'
  > | null
): string {
  const { feedName, providerIdOrigin } = entity ?? {}
  const isEvolve = providerIdOrigin?.includes('rentals_united.evolve')
  const isJuneHomes = providerIdOrigin?.includes('rentals_united.june_homes')

  if (isEvolve) {
    return EVOLVE
  }
  if (isJuneHomes) {
    return JUNE_HOMES
  }
  return feedName ?? ''
}
